import { useMemo, useEffect } from "react";

import { getTotalKeywordsName } from "../../../consts";
import { useCommonVisitsOvertime } from "../hooks/useCommonVisitsOvertime";
import { useVisitsOvertimeData } from "../hooks/useVisitsOvertimeData";
import { createChartData, createLegendItem, createTopAndOtherLegendItems } from "../utils";

import { processSingleModeData, buildLegendSources } from "./utils";

export const useVisitsOvertimeSingleMode = () => {
    const { data, isLoading, excelUrl } = useVisitsOvertimeData();
    const { legendItems, setLegendItems, colorStack, config } = useCommonVisitsOvertime();

    const { processedData, availableLobs, lobVisitsData } = useMemo(() => processSingleModeData(data), [data]);

    const createLegendItems = useMemo(() => {
        if (!processedData) {
            return [];
        }

        const { total, breakdown, siteVisits } = processedData;
        colorStack.current.reset();

        const legendSources = buildLegendSources(total, breakdown, siteVisits);
        const { items, top } = createTopAndOtherLegendItems(legendSources, colorStack, createLegendItem);

        const domainName = Object.keys(data || {})[0] || "Total";
        const totalSource = legendSources.find((source) => source.name === getTotalKeywordsName());

        if (totalSource) {
            items.push(
                createLegendItem({
                    name: domainName,
                    visible: top.length === 1,
                    visits: totalSource.visits,
                    isTotal: true,
                }),
            );
        }

        return items;
    }, [processedData, data, colorStack]);

    useEffect(() => {
        setLegendItems(createLegendItems);
    }, [createLegendItems, setLegendItems]);

    const chartData = createChartData(processedData, legendItems);
    const visibleChartData = chartData.filter((series) => series.visible);

    return {
        isLoading,
        config,
        legendItems,
        chartData,
        visibleChartData,
        setLegendItems,
        availableLobs,
        lobVisitsData,
        excelUrl,
    };
};
